<script lang="ts">
	interface Props {
		onclick?: () => void;
	}

	let { onclick }: Props = $props();
</script>

<button type="button" aria-label="Close dialog" {onclick} class="fixed inset-0 z-50 bg-[black]/50"
></button>
